<template>
    <div class="bg-tc-gray-5 hidden sm:block absolute bottom-0 w-full">
        <div class="footer-body">
            <div class="grid grid-cols-2 pt-9">
                <div>
                    <div class="zone-width m-auto">
                        <div class="text-tc-blue-1 text-20">Dhipaya Insurance Public Company Limited</div>
                        <div class="text-tc-blue-1 text-18">No. 1115 Rama 3 Rd., Chong Nonsi Subdistrict, <br>Yannawa District, Bangkok 10120.</div>
                    </div>
                </div>
                <div>
                    <div class="zone-width m-auto">
                        <div class="text-tc-blue-1 text-20">{{ lbl.home.more_information }}</div>
                        <div class="mt-3">
                            <BlueBtn class="text-30" @click="clickTelCallcenter()">
                                <div class="flex items-center">
                                    <div class="mr-2"><img class="w-4" src="../../../assets/icon/tel-icon.png"></div>
                                    <div>Dhipaya Callcenter 1736</div>
                                </div>
                            </BlueBtn>
                        </div>
                    </div>
                </div>
            </div>
            <div class="my-2">
                <img class="logo-powerby m-auto" src="../../../assets/logo/power-tip.png">
            </div>
        </div>
        <div class="border-t border-tc-blue-1 text-center py-1 text-18 text-tc-blue-1">
            Copyright 2021 Dhipaya Insurance Public Company Limited.
        </div>

    </div>
</template>
<script>
import BlueBtn from "@/components/Button/BlueBtn.vue"
import LocaleMixin from '@/mixin/LocaleMixin'
export default {
    name: 'BottomBar',
    mixins: [LocaleMixin],
    components: {
        BlueBtn,
    },
    methods: {
        clickTelCallcenter: function() {
            window.location = 'tel://1736';
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .zone-width {
        max-width: 290px;
    }
    .logo-powerby {
        width: 166px;
    }
    .footer-body {
        margin: auto;
        max-width: $page-max-width;
    }
</style>
